// src/components/Filter.jsx
import React from "react";

const Filter = ({ value, onChange }) => {
    return (
        <select
            className="form-select border-1 px-2"
            style={{ width: "90px", padding: "3px 0px", borderColor: "#3b6353" }}
            value={value}
            onChange={onChange}
        >
            <option value="desc">Newest</option>
            <option value="asc">Oldest</option>
        </select>
    );
};

export default Filter;
